// PlaidLinkOpener.jsx
import React, { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';

const PlaidLinkOpener = ({ token, onSuccess, onClose, onError }) => {
  const { open, ready } = usePlaidLink({
    token,
    onSuccess,
    onExit: (err, metadata) => {
      console.warn('Plaid exited:', err, metadata);
      if (err) {
        if (onError) {
          onError(err, metadata);
        }
      }
      onClose();
    },
    onEvent: (eventName, metadata) => {
      console.log('Plaid event:', eventName, metadata);
    },
  });

  useEffect(() => {
    if (ready && token) {
      open(); // auto-opens when ready
    }
  }, [ready, token, open]);

  return null; // No button needed since it opens automatically
};

export default PlaidLinkOpener;
